module.exports = __webpack_public_path__ + "media/images/lp_v10_mv_title_1-9d8da30e39c9c27b09ee483a320b74a9.webp";